import { Component, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Job } from "@app/models/rest/job";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { JobStore } from "@app/services/store/job-store";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { GridComponent } from "../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
  imports: [GridComponent, MatPaginator]
})
export class SearchComponent
  extends BaseDataTablePageDirective<Job>
  implements OnInit
{
  protected jobStore: JobStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  public columns: object[] = [
    {
      field: "externalJobReference",
      text: "Job",
      flex: 1,
      editor: false
    },
    {
      field: "externalPropertyReference",
      text: "Property",
      flex: 1,
      editor: false
    },
    {
      field: "planningWindowEnd",
      text: "Target Date",
      flex: 1,
      format: "YYYY-MM-DD",
      type: "date",
      editor: false
    },
    {
      field: "planningWindowEnd",
      text: "Target Time",
      flex: 1,
      format: "HH:mm:ss",
      type: "time",
      editor: false
    },
    {
      field: "status",
      text: "Status",
      flex: 1,
      editor: false
    },
    {
      field: "location.latitude",
      text: "Latitude",
      flex: 1,
      type: "number",
      editor: false
    },
    {
      field: "location.longitude",
      text: "Longitude",
      flex: 1,
      type: "number",
      editor: false
    },
    {
      field: "location.postCode",
      text: "Post Code",
      flex: 1,
      editor: false
    },
    {
      field: "zone.name",
      text: "Zone",
      flex: 1,
      editor: false
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const jobStore = inject(JobStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      jobStore,
      store,
      dialog,
      "Job",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.jobStore = jobStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  openJob(job: Job) {
    this.router.navigate(["/jobs", "detail", job.id]).then();
  }

  gridTotalChange($event: any) {
    console.log("total change");
    console.log($event);
  }
}
